import _ from "lodash";
import {
  ICreateCustomerDTO, ICreateCustomerFormData, ICreateTransactionDTO,
  IUpdateCompanyDTO
} from "../resources/interfaces";
import { getFormattedPhoneNumber, getPhoneNumberFromShortCodeFormat, safeDate, safeString } from "../utilities/miscFunctions";
import { SERVER_DATE_FORMAT } from "./constants";
import moment from "moment";
import { CURRENCIES, GENDER, ID_TYPES, MARITAL_STATUS, TRANSACTION_TYPES } from "./enums";
import { ICreateTransactionFormData } from "../views/transactions/AddTransaction";
import { ICreateCompanyFormData } from "../views/companies/AddCompany";
import { Company, CustomerPerson, Person } from "./types";
import { BLANK_CUSTOMER_DATA, Customer } from "../components/models/customer/Customer";

export function formDataToCreateCustomerDTO(
  data: ICreateCustomerFormData
): ICreateCustomerDTO {
  return {
    ...data,
    phone: getFormattedPhoneNumber(data.phone),
    street_address: data.streetAddress,
    digital_address: data.digitalAddress,
    region: data.region,
    email: safeString(data.email)
  };
}

export function customerDataToFormData(
  data?: Customer
): ICreateCustomerFormData {
  if (!data) {
    return BLANK_CUSTOMER_DATA;
  }

  return {
    ...data,
    phone: getPhoneNumberFromShortCodeFormat(data?.phone ?? ""),
    streetAddress: data?.address?.street_address ?? "",
    digitalAddress: data?.address?.digital_address ?? "",
    region: data?.address?.region ?? "",
    city: data?.address?.city ?? "",
    members: data ? data.members?.map((member: CustomerPerson) => (
      {
        ...member,
        ...member.person,
        ...member.person.address,
        id_expiry_date: safeDate(member.person.id_expiry_date),
        id_issued_date: safeDate(member.person.id_issued_date),
        date_of_birth: safeDate(member.person.date_of_birth),
      }
    )) : []
  };
}

export function formDataToCreateTransactionDTO(
  data: ICreateTransactionFormData
): ICreateTransactionDTO {
  return {
    ...data,
    transactor_phone: getFormattedPhoneNumber(data.transactor_phone),
    type: data.type as TRANSACTION_TYPES,
    transactor_id_type: data.transactor_id_type as ID_TYPES
  };
}

export function companyDataToCompanyDTO(
  data: Company
): IUpdateCompanyDTO {
  return {
    ...data,
    digital_address: data.address?.digital_address ?? "",
    city: data.address?.city ?? "",
    region: data.address?.region ?? "",
    address: data.address?.street_address ?? "",
    country: data.address?.country ?? ""
  };
}
